import styled from "styled-components";
import { Menu } from "antd";

export const Navigation = styled(Menu)`
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #334d6e;

  .ant-menu-item,
  .ant-menu-submenu-title {
    width: auto;
  }

  .ant-menu-sub {
    background-color: #fff;
    font-size: 11px;

    li.ant-menu-item {
      height: 3rem;
    }
  }

  .ant-menu-item-icon {
    svg {
      stroke: #4f4f4f;
    }
  }

  .ant-menu-item-active,
  .ant-menu-submenu,
  .ant-menu-item-selected {
    .ant-menu-item-icon {
      svg {
        stroke: ${({ theme }) => theme.colors.blueDianne};
      }
    }
  }
`;
